/**
 * Reset per-stock chart overlay data when the user switches company.
 * Quote history lives on a new dataFeed; these Redux series are shared and
 * otherwise accumulate (media messages, OPS/OPD, insider markers).
 */
export default function applyTvChartStockChangeDataReset({
  stockId,
  resetChartMarkerData,
  refreshReportDates,
  refreshDividends,
  refreshPriceAlerts,
  refreshInsiderTransactions
}) {
  if (!stockId) {
    return;
  }

  resetChartMarkerData?.(stockId);
  refreshReportDates?.(stockId);
  refreshDividends?.(stockId);
  refreshPriceAlerts?.(stockId);
  refreshInsiderTransactions?.(stockId);
}
